'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var nthGrid = require('@narvar/nth-grid');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const DT_DEFAULT_GUTTER_HALF_WIDTH = '0.25rem';
const DT_DEFAULT_MAX_WIDTH = '952px';

/* eslint-disable @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-assignment */

const {
  component: containerComponent
} = nthGrid.styledBreakpoint()(nthGrid.gridContainer({
  gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH,
  gridContainerMaxWidths: {
    lg: DT_DEFAULT_MAX_WIDTH,
    xl: DT_DEFAULT_MAX_WIDTH
  }
})(styled__default["default"].div.withConfig({
  componentId: "sc-1ngwfjo-0"
})([""])));
const {
  component: columnComponent
} = nthGrid.styledBreakpoint()(nthGrid.gridGutterColumn({
  gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH
})(nthGrid.gridColumnOffset()(nthGrid.gridColumn()(styled__default["default"].div.withConfig({
  componentId: "sc-1ngwfjo-1"
})(["min-height:1px;"])))));
const {
  component: rowComponent
} = nthGrid.styledBreakpoint()(nthGrid.gridGutterRow({
  gutterHalfWidth: DT_DEFAULT_GUTTER_HALF_WIDTH
})(nthGrid.gridRow()(styled__default["default"].div.withConfig({
  componentId: "sc-1ngwfjo-2"
})([""]))));

exports.DT_DEFAULT_MAX_WIDTH = DT_DEFAULT_MAX_WIDTH;
exports.columnComponent = columnComponent;
exports.containerComponent = containerComponent;
exports.rowComponent = rowComponent;
